// Soma Lixir — shared data constants

export const CAFE_NAME = "FLORA CAFE";

export const LENSES = [
  {
    name: "relationships",
    label: "Relationships",
    tarot: "lovers",
    tarotName: "The Lovers",
    instruction:
      "Frame your interpretation primarily through the lens of relationships and connection with others — friendships, romance, family, community, how the person relates to people around them.",
  },
  {
    name: "work_and_purpose",
    label: "Career & Purpose",
    tarot: "magician",
    tarotName: "The Magician",
    instruction:
      "Frame your interpretation primarily through the lens of work, ambition, purpose, or the person's path/direction in life — career, creative projects, sense of contribution.",
  },
  {
    name: "inner_state",
    label: "Inner State",
    tarot: "hermit",
    tarotName: "The Hermit",
    instruction:
      "Frame your interpretation primarily through the lens of the person's internal emotional or mental state right now — how they're feeling, processing, or carrying something inwardly, independent of any external situation.",
  },
  {
    name: "change_and_transition",
    label: "Change & Transition",
    tarot: "wheel",
    tarotName: "Wheel of Fortune",
    instruction:
      "Frame your interpretation primarily through the lens of change, transition, or a threshold the person is near — something ending, beginning, or shifting in their life right now.",
  },
  {
    name: "rest_and_restoration",
    label: "Rest & Restoration",
    tarot: "star",
    tarotName: "The Star",
    instruction:
      "Frame your interpretation primarily through the lens of rest, depletion, or restoration — whether the person is running on empty, recovering, or needing to protect their energy.",
  },
  {
    name: "creativity",
    label: "Creativity",
    tarot: "empress",
    tarotName: "The Empress",
    instruction:
      "Frame your interpretation primarily through the lens of creativity, self-expression, or something the person wants to make or say but hasn't fully yet.",
  },
  {
    name: "decision",
    label: "A Decision",
    tarot: "hangedman",
    tarotName: "The Hanged Man",
    instruction:
      "Frame your interpretation primarily through the lens of a specific decision or choice the person is weighing right now, even if they haven't named it yet.",
  },
];

export const GROUNDING_PROMPTS = [
  "Take slow, deep breaths. In for four counts, out for four.",
  "Name three things you're grateful for right now, even small ones.",
  "Feel your feet on the floor. Notice where they touch the ground.",
  "Soften your shoulders. Let them drop away from your ears.",
  "Notice one sound around you right now. Just listen.",
  "Place a hand on your chest and feel your own heartbeat.",
  "Think of someone who makes you feel safe. Picture their face.",
  "Unclench your jaw. Let your tongue rest soft in your mouth.",
  "Name one thing you're looking forward to, however small.",
  "Notice the temperature of the air on your skin.",
  "Let your eyes soften, not quite closed, not quite focused.",
  "Think of a place that feels like home. Sit there for a moment.",
  "Roll your shoulders back, once, slowly.",
  "Notice the weight of your own body in the chair or on your feet.",
  "Think of one thing you did today that you're proud of.",
  "Breathe in for a count of four, hold for four, release for four.",
  "Notice the cup in front of you. What does it still smell like?",
  "Let your hands rest open, palms up, just for these seconds.",
  "Think of a person you haven't thought of in a while. Send them well.",
  "Notice the four walls or open sky around you. You are here, now.",
];

export const BEVERAGE_PAUSE_PROMPTS = [
  "Hold your cup for a moment before the next sip. Notice its weight in your hands.",
  "Before you drink, notice the smell rising off the top. What does it remind you of?",
  "Take one slow sip. Notice where you feel it — your chest, your throat, your hands warming.",
  "Look at the color of what's left. Just look, without rushing to finish it.",
  "Notice if you're drinking out of habit or out of want right now. No judgment, just noticing.",
  "Before the next sip, take one full breath in through your nose, and let it out slowly.",
  "Notice the temperature against your hands. Is it still warm? Has it cooled?",
  "Pause and ask: what does my body actually want right now — more, or stillness?",
  "Look at the surface of your drink. Is it still, or moving? Let that be enough for now.",
  "Notice one sound in the room while you hold your cup. Just for a breath.",
];

export const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];
